<template>
  <section v-if="loading">
    <PaginaCarga />
  </section>
  <section class="container-404">
    <div class="container-404-box">
      <svg
        v-if="isMovile"
        id="Capa_2-404"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 927.25 535.72"
      >
        <g id="Capa_1-2">
          <g>
            <path
              class="cls-404-5"
              d="M912.45,441.47c-56.26,44.57-149.55,29.68-444.51,79.83C118.35,580.72-34.63,440.06,6.55,397.63c63.19-65.11,198.51-49.8,458.02-59.16,453.9-16.36,494.23,66.27,447.88,102.99Z"
            />
            <g class="mov">
              <g>
                <path
                  class="cls-404-4"
                  d="M84.95,304.03l230.28,132.94c5.05,2.91,13.23,2.91,18.27,0L838.08,145.68c5.05-2.91,5.05-7.64,0-10.55L607.8,2.19c-5.05-2.91-13.23-2.91-18.27,0L84.95,293.48c-5.05,2.91-5.05,7.64,0,10.55Z"
                />
                <path
                  class="cls-404-7"
                  d="M209.41,365.79c7.01,4.05,18.37,4.05,25.38,0,7.01-4.05,7.01-10.61,0-14.65-7.01-4.05-18.37-4.05-25.38,0-7.01,4.05-7.01,10.61,0,14.65Z"
                />
                <path
                  class="cls-404-8"
                  d="M319.45,436.97L89.17,304.03c-4.51-2.6-4.98-6.65-1.42-9.57-4.37,3.31-7.72,9.58-7.72,14.84v8.59c0,5.83,4.09,12.91,9.14,15.83l230.28,132.94c2.52,1.46,5.83,2.19,9.14,2.19v-29.69c-3.31,0-6.61-.73-9.14-2.19Z"
                />
                <path
                  class="cls-404-7"
                  d="M838.08,175.37c5.05-2.91,9.14-10,9.14-15.82v-8.59c0-5.27-3.35-11.53-7.73-14.84,3.57,2.91,3.11,6.96-1.41,9.57L333.51,436.97c-2.52,1.46-5.83,2.19-9.14,2.19v29.69c3.31,0,6.61-.73,9.14-2.19L838.08,175.37Z"
                />
                <path
                  class="cls-404-6"
                  d="M353.18,409.43l-220.42-127.32c-3.03-1.75-3.03-4.58,0-6.33L558.83,29.73c3.03-1.75,7.94-1.75,10.96,0l220.5,127.3c3.03,1.75,3.03,4.58,0,6.33l-426.15,246.06c-3.03,1.75-7.94,1.75-10.96,0Z"
                />
                <path
                  class="cls-404-1"
                  d="M790.29,157.03l-32.27-18.63c-25.7,17.55-55.15,30.23-82.67,43.88-19.36,9.6-38.71,18.62-58.9,26.39-21.37,8.23-42.67,16.49-63.91,25.04-40.25,16.21-82.27,27.5-125.3,33.14-44.58,5.85-89.71,5.72-134.18-.95-35.75-5.36-70.86-14.06-106.24-21.36l-54.07,31.22c-3.03,1.75-3.03,4.58,0,6.33l220.42,127.32c3.03,1.75,7.94,1.75,10.96,0l426.15-246.06c3.03-1.75,3.03-4.58,0-6.33Z"
                />
                <g>
                  <path
                    class="cls-404-7"
                    d="M706.91,78.49c1.77,1.03,4.65,1.02,6.43,0,1.78-1.02,1.78-2.69,0-3.71-1.77-1.02-4.65-1.02-6.43,0-1.78,1.02-1.78,2.69,0,3.71Z"
                  />
                  <path
                    class="cls-404-7"
                    d="M717.18,107.64c3.55,2.05,9.31,2.05,12.86,0,3.55-2.05,3.55-5.37,0-7.42-3.55-2.05-9.31-2.05-12.86,0-3.55,2.05-3.55,5.37,0,7.42Z"
                  />
                  <path
                    class="cls-404-7"
                    d="M708.11,94.72c2.37-1.37,2.24-3.65-.28-5.11l-42.29-24.42c-2.52-1.46-6.49-1.53-8.85-.16-2.37,1.37-2.24,3.66,.28,5.11l42.29,24.42c2.52,1.46,6.49,1.53,8.85,.16Z"
                  />
                </g>
              </g>
              <g>
                <path
                  class="cls-404-2"
                  d="M477.47,275.93l-102.56-71.14c-9.2-6.38-8.12-17.85,2.4-25.62l35.7-26.37c10.52-7.77,26.51-8.9,35.71-2.52l102.56,71.14c9.2,6.38,8.12,17.85-2.4,25.62l-35.7,26.37c-10.52,7.77-26.51,8.9-35.71,2.52Z"
                />
                <g>
                  <path
                    class="cls-404-3"
                    d="M419.88,206.29l-6.71,3.7-11.79-8.17,6.71-3.7-18.8-13.04,10.58-5.77,41.42-10.88,11.51,7.99-36.13,10.51,5.26,3.65,12-6.59,11.79,8.18-12,6.59,4.28,2.97-13.84,7.55-4.28-2.97Z"
                  />
                  <path
                    class="cls-404-3"
                    d="M485.98,224.03c-15.37,11.35-35.89,12.92-48.49,4.18-9.54-6.62-7.97-15.86,2.94-23.92,15.36-11.35,35.88-12.92,48.49-4.18,9.48,6.58,7.97,15.86-2.94,23.92Zm-13.51-6.59c4.77-3.52,5.82-7.28,2.36-9.68-4.88-3.38-13.81-2.12-20.9,3.11-4.77,3.52-5.87,7.24-2.37,9.68,4.82,3.35,13.81,2.13,20.9-3.11Z"
                  />
                  <path
                    class="cls-404-3"
                    d="M496.5,259.44l-6.71,3.7-11.79-8.17,6.71-3.7-18.8-13.04,10.58-5.77,41.42-10.88,11.51,7.99-36.13,10.51,5.26,3.65,12-6.59,11.79,8.18-12,6.59,4.28,2.97-13.84,7.55-4.28-2.97Z"
                  />
                </g>
              </g>
              <path
                class="cls-404-3"
                d="M136.88,176.04l4.11,16.51c.76,3.07,3.16,5.46,6.22,6.22l16.51,4.11-16.51,4.11c-3.07,.76-5.46,3.16-6.22,6.22l-4.11,16.51-4.11-16.51c-.76-3.07-3.16-5.46-6.22-6.22l-16.51-4.11,16.51-4.11c3.07-.76,5.46-3.16,6.22-6.22l4.11-16.51Z"
              />
              <path
                class="cls-404-3"
                d="M128.76,89.01l3.55,14.25c.66,2.65,2.73,4.71,5.37,5.37l14.25,3.55-14.25,3.55c-2.65,.66-4.71,2.73-5.37,5.37l-3.55,14.25-3.55-14.25c-.66-2.65-2.73-4.71-5.37-5.37l-14.25-3.55,14.25-3.55c2.65-.66,4.71-2.73,5.37-5.37l3.55-14.25Z"
              />
              <path
                class="cls-404-3"
                d="M81,133.57l1.95,7.85c.36,1.46,1.5,2.6,2.96,2.96l7.85,1.95-7.85,1.95c-1.46,.36-2.6,1.5-2.96,2.96l-1.95,7.85-1.95-7.85c-.36-1.46-1.5-2.6-2.96-2.96l-7.85-1.95,7.85-1.95c1.46-.36,2.6-1.5,2.96-2.96l1.95-7.85Z"
              />
              <path
                class="cls-404-3"
                d="M884.87,147.88l2.79,11.21c.52,2.08,2.14,3.71,4.23,4.23l11.21,2.79-11.21,2.79c-2.08,.52-3.71,2.14-4.23,4.23l-2.79,11.21-2.79-11.21c-.52-2.08-2.14-3.71-4.23-4.23l-11.21-2.79,11.21-2.79c2.08-.52,3.71-2.14,4.23-4.23l2.79-11.21Z"
              />
              <path
                class="cls-404-3"
                d="M860.25,64.05l2.65,10.66c.49,1.98,2.04,3.53,4.02,4.02l10.66,2.65-10.66,2.65c-1.98,.49-3.53,2.04-4.02,4.02l-2.65,10.66-2.65-10.66c-.49-1.98-2.04-3.53-4.02-4.02l-10.66-2.65,10.66-2.65c1.98-.49,3.53-2.04,4.02-4.02l2.65-10.66Z"
              />
              <path
                class="cls-404-3"
                d="M851.71,212.28l2.2,8.82c.41,1.64,1.69,2.92,3.33,3.33l8.82,2.2-8.82,2.2c-1.64,.41-2.92,1.69-3.33,3.33l-2.2,8.82-2.2-8.82c-.41-1.64-1.69-2.92-3.33-3.33l-8.82-2.2,8.82-2.2c1.64-.41,2.92-1.69,3.33-3.33l2.2-8.82Z"
              />
            </g>
          </g>
        </g>
      </svg>
      <svg
        v-else
        id="Capa_2-404"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 556.02 365.19"
        class="container-404__img"
      >
        <g id="Capa">
          <g>
            <path
              class="cls-404-11"
              d="M547.15,308.67c-33.73,26.73-89.68,17.8-266.55,47.87C70.97,392.17-20.77,307.82,3.93,282.38c37.89-39.04,119.04-29.86,274.65-35.47,272.18-9.81,296.36,39.74,268.57,61.76Z"
            />
            <g>
              <polygon
                class="cls-404-10"
                points="438.14 239.18 202.07 258.91 117.25 212.39 370.82 198.56 438.14 239.18"
              />
              <polygon
                class="cls-404-6"
                points="117.25 212.39 117.25 282.61 202.07 330.87 202.07 258.91 117.25 212.39"
              />
              <g>
                <g>
                  <path
                    class="cls-404-15"
                    d="M136.04,253.32l-14.03-8.13c-.64-.37-1.16-1.19-1.16-1.83h0c0-.64,.52-.86,1.16-.49l14.03,8.13c.64,.37,1.16,1.19,1.16,1.83h0c0,.64-.52,.86-1.16,.49Z"
                  />
                  <path
                    class="cls-404-15"
                    d="M155.52,264.61l-14.03-8.13c-.64-.37-1.16-1.19-1.16-1.83h0c0-.64,.52-.86,1.16-.49l14.03,8.13c.64,.37,1.16,1.19,1.16,1.83h0c0,.64-.52,.86-1.16,.49Z"
                  />
                  <path
                    class="cls-404-15"
                    d="M175,275.9l-14.03-8.13c-.64-.37-1.16-1.19-1.16-1.83h0c0-.64,.52-.86,1.16-.49l14.03,8.13c.64,.37,1.16,1.19,1.16,1.83h0c0,.64-.52,.86-1.16,.49Z"
                  />
                  <path
                    class="cls-404-15"
                    d="M194.48,287.19l-14.03-8.13c-.64-.37-1.16-1.19-1.16-1.83h0c0-.64,.52-.86,1.16-.49l14.03,8.13c.64,.37,1.16,1.19,1.16,1.83h0c0,.64-.52,.86-1.16,.49Z"
                  />
                </g>
                <g>
                  <path
                    class="cls-404-15"
                    d="M136.04,257.78l-14.03-8.13c-.64-.37-1.16-1.19-1.16-1.83h0c0-.64,.52-.86,1.16-.49l14.03,8.13c.64,.37,1.16,1.19,1.16,1.83h0c0,.64-.52,.86-1.16,.49Z"
                  />
                  <path
                    class="cls-404-15"
                    d="M155.52,269.07l-14.03-8.13c-.64-.37-1.16-1.19-1.16-1.83h0c0-.64,.52-.86,1.16-.49l14.03,8.13c.64,.37,1.16,1.19,1.16,1.83h0c0,.64-.52,.86-1.16,.49Z"
                  />
                  <path
                    class="cls-404-15"
                    d="M175,280.36l-14.03-8.13c-.64-.37-1.16-1.19-1.16-1.83h0c0-.64,.52-.86,1.16-.49l14.03,8.13c.64,.37,1.16,1.19,1.16,1.83h0c0,.64-.52,.86-1.16,.49Z"
                  />
                  <path
                    class="cls-404-15"
                    d="M194.48,291.65l-14.03-8.13c-.64-.37-1.16-1.19-1.16-1.83h0c0-.64,.52-.86,1.16-.49l14.03,8.13c.64,.37,1.16,1.19,1.16,1.83h0c0,.64-.52,.86-1.16,.49Z"
                  />
                </g>
                <g>
                  <path
                    class="cls-404-15"
                    d="M136.04,262.24l-14.03-8.13c-.64-.37-1.16-1.19-1.16-1.83h0c0-.64,.52-.86,1.16-.49l14.03,8.13c.64,.37,1.16,1.19,1.16,1.83h0c0,.64-.52,.86-1.16,.49Z"
                  />
                  <path
                    class="cls-404-15"
                    d="M155.52,273.53l-14.03-8.13c-.64-.37-1.16-1.19-1.16-1.83h0c0-.64,.52-.86,1.16-.49l14.03,8.13c.64,.37,1.16,1.19,1.16,1.83h0c0,.64-.52,.86-1.16,.49Z"
                  />
                  <path
                    class="cls-404-15"
                    d="M175,284.82l-14.03-8.13c-.64-.37-1.16-1.19-1.16-1.83h0c0-.64,.52-.86,1.16-.49l14.03,8.13c.64,.37,1.16,1.19,1.16,1.83h0c0,.64-.52,.86-1.16,.49Z"
                  />
                  <path
                    class="cls-404-15"
                    d="M194.48,296.11l-14.03-8.13c-.64-.37-1.16-1.19-1.16-1.83h0c0-.64,.52-.86,1.16-.49l14.03,8.13c.64,.37,1.16,1.19,1.16,1.83h0c0,.64-.52,.86-1.16,.49Z"
                  />
                </g>
                <g>
                  <path
                    class="cls-404-15"
                    d="M136.04,266.7l-14.03-8.13c-.64-.37-1.16-1.19-1.16-1.83h0c0-.64,.52-.86,1.16-.49l14.03,8.13c.64,.37,1.16,1.19,1.16,1.83h0c0,.64-.52,.86-1.16,.49Z"
                  />
                  <path
                    class="cls-404-15"
                    d="M155.52,277.99l-14.03-8.13c-.64-.37-1.16-1.19-1.16-1.83h0c0-.64,.52-.86,1.16-.49l14.03,8.13c.64,.37,1.16,1.19,1.16,1.83h0c0,.64-.52,.86-1.16,.49Z"
                  />
                  <path
                    class="cls-404-15"
                    d="M175,289.28l-14.03-8.13c-.64-.37-1.16-1.19-1.16-1.83h0c0-.64,.52-.86,1.16-.49l14.03,8.13c.64,.37,1.16,1.19,1.16,1.83h0c0,.64-.52,.86-1.16,.49Z"
                  />
                  <path
                    class="cls-404-15"
                    d="M194.48,300.56l-14.03-8.13c-.64-.37-1.16-1.19-1.16-1.83h0c0-.64,.52-.86,1.16-.49l14.03,8.13c.64,.37,1.16,1.19,1.16,1.83h0c0,.64-.52,.86-1.16,.49Z"
                  />
                </g>
                <g>
                  <path
                    class="cls-404-15"
                    d="M136.04,271.16l-14.03-8.13c-.64-.37-1.16-1.19-1.16-1.83h0c0-.64,.52-.86,1.16-.49l14.03,8.13c.64,.37,1.16,1.19,1.16,1.83h0c0,.64-.52,.86-1.16,.49Z"
                  />
                  <path
                    class="cls-404-15"
                    d="M155.52,282.44l-14.03-8.13c-.64-.37-1.16-1.19-1.16-1.83h0c0-.64,.52-.86,1.16-.49l14.03,8.13c.64,.37,1.16,1.19,1.16,1.83h0c0,.64-.52,.86-1.16,.49Z"
                  />
                  <path
                    class="cls-404-15"
                    d="M175,293.73l-14.03-8.13c-.64-.37-1.16-1.19-1.16-1.83h0c0-.64,.52-.86,1.16-.49l14.03,8.13c.64,.37,1.16,1.19,1.16,1.83h0c0,.64-.52,.86-1.16,.49Z"
                  />
                  <path
                    class="cls-404-15"
                    d="M194.48,305.02l-14.03-8.13c-.64-.37-1.16-1.19-1.16-1.83h0c0-.64,.52-.86,1.16-.49l14.03,8.13c.64,.37,1.16,1.19,1.16,1.83h0c0,.64-.52,.86-1.16,.49Z"
                  />
                </g>
              </g>
              <polygon
                class="cls-404-8"
                points="202.07 330.87 438.14 308.82 438.14 239.18 202.07 258.91 202.07 330.87"
              />
              <path
                class="cls-404-15"
                d="M390.38,263.82l-11.15,.92-20.14,1.66c-1.35,.11-2.41,1.25-2.41,2.61h0c0,1.49,1.26,2.64,2.74,2.52l19.07-1.57c.4,1.51,1.28,2.92,2.77,3.89,2.29,1.48,5.38,1.43,7.65-.16,1.73-1.22,2.66-2.99,2.89-4.83l19.24-1.58c1.35-.11,2.41-1.25,2.41-2.61h0c0-1.49-1.26-2.64-2.74-2.52l-20.32,1.67Z"
              />
              <g>
                <path
                  class="cls-404-4"
                  d="M369.48,290.18c.11,2.82-2.09,5.19-4.91,5.3-2.82,.11-5.19-2.09-5.3-4.91-.11-2.82,2.09-5.19,4.91-5.3,2.82-.11,5.19,2.09,5.3,4.91Z"
                />
                <path
                  class="cls-404-4"
                  d="M388.48,288.51c.11,2.82-2.09,5.19-4.91,5.3-2.82,.11-5.19-2.09-5.3-4.91-.11-2.82,2.09-5.19,4.91-5.3,2.82-.11,5.19,2.09,5.3,4.91Z"
                />
                <path
                  class="cls-404-4"
                  d="M407.47,286.84c.11,2.82-2.09,5.19-4.91,5.3-2.82,.11-5.2-2.09-5.3-4.91-.11-2.82,2.09-5.19,4.91-5.3,2.82-.11,5.19,2.09,5.3,4.91Z"
                />
              </g>
              <g>
                <g>
                  <polygon
                    class="cls-404-8"
                    points="376.05 232.5 254.94 242.16 208.88 217.36 338.69 209.95 376.05 232.5"
                  />
                  <polygon
                    class="cls-404-13"
                    points="208.88 217.36 208.88 222.71 254.94 247.51 254.94 242.16 208.88 217.36"
                  />
                  <polygon
                    class="cls-404-7"
                    points="254.94 242.16 376.05 232.5 376.05 237.85 254.94 247.51 254.94 242.16"
                  />
                </g>
                <g>
                  <g>
                    <path
                      class="cls-404-4"
                      d="M245.12,218.42v8.05c.19,4.83,27.6,8.01,54.38,6.93,26.78-1.07,42-10.23,42.61-13.02v-10l-96.99,8.04Z"
                    />
                    <path
                      class="cls-404-3"
                      d="M245.12,218.42v8.05c.12,3.08,11.33,5.49,26.38,6.55v-16.78l-26.38,2.19Z"
                    />
                  </g>
                  <polygon
                    class="cls-404-6"
                    points="215.53 210.75 215.53 230.04 395.31 213.95 395.31 196.08 215.53 210.75"
                  />
                  <path
                    class="cls-404-14"
                    d="M170.95,185.4v6.23c0,9.48,5.3,18.17,13.73,22.52l30.85,15.89v-19.29l-34.15-18.06c-3.82-2-7.3-4.47-10.43-7.28Z"
                  />
                  <polygon
                    class="cls-404-10"
                    points="411.81 199.37 202.17 214.56 202.17 0 411.81 12.14 411.81 199.37"
                  />
                  <path
                    class="cls-404-15"
                    d="M225.14,16.08l167.26,11.04c3.23,.21,5.74,2.89,5.74,6.13V178.57c0,3.2-2.46,5.87-5.65,6.12l-167.26,13.44c-3.57,.29-6.63-2.54-6.63-6.12V22.21c0-3.55,3-6.36,6.55-6.13Z"
                  />
                  <path
                    class="cls-404-2"
                    d="M236.67,27.34h21.82c36.11,.01,72.17,2.52,107.94,7.51l14.66,2.05c3.55,.5,6.28,3.4,6.55,6.98l.43,5.79c3.05,40.66,2.91,77.82-.4,118.46h0c-.29,3.52-2.95,6.38-6.45,6.92l-15.64,2.4c-35.59,5.45-71.52,8.45-107.52,8.95l-21.31,.3c-4.05,.06-7.44-3.07-7.72-7.11l-1.44-21.29c-2.36-34.88-2.38-66.21-.06-101.09l1.51-22.75c.27-4.01,3.6-7.12,7.61-7.12Z"
                  />
                  <path
                    class="cls-404-1"
                    d="M234.74,184.79c-3,0-5.5-2.34-5.7-5.33l-1.44-21.29c-2.34-34.67-2.37-66.16-.06-100.84l1.51-22.75c.2-2.99,2.71-5.34,5.71-5.34h21.82c35.89,.01,72.12,2.53,107.67,7.49l14.66,2.04c2.65,.37,4.71,2.57,4.91,5.24l.43,5.79c3.03,40.43,2.89,77.75-.4,118.17-.22,2.65-2.2,4.78-4.83,5.19l-15.64,2.4c-35.38,5.42-71.46,8.43-107.26,8.93l-21.4,.3Z"
                  />
                  <path
                    class="cls-404-12"
                    d="M384.39,51.57c-.04-.59-.07-1.18-.11-1.76l-.43-5.79c-.2-2.66-2.27-4.87-4.91-5.24l-14.66-2.04c-35.55-4.96-71.78-7.48-107.67-7.49h-21.82c-3,0-5.51,2.34-5.71,5.33l-1.51,22.75c-2.16,32.46-2.25,61.67-.34,94.18,1.08,.02,2.16,.04,3.25,.04,69.64,0,129.26-39.2,153.93-99.98Z"
                  />
                  <polygon
                    class="cls-404-9"
                    points="167.08 14.11 202.17 0 202.17 214.56 168.02 198.41 167.08 14.11"
                  />
                  <path
                    class="cls-404-14"
                    d="M155.82,182.59l-22.81-11.56c-8.35-4.23-13.58-12.59-13.58-21.69V72.13c0-9.11,5.23-17.46,13.58-21.69l22.81-11.56V182.59Z"
                  />
                  <path
                    class="cls-404-6"
                    d="M167.08,14.11l-6.21,4.71c-12.81,9.72-20.36,24.97-20.36,41.16v92.74c0,19.23,10.61,36.86,27.51,45.7h0"
                  />
                </g>
              </g>
              <rect
                class="cls-404-4"
                x="363.64"
                y="50.41"
                width="11.89"
                height="33.04"
                rx="5.95"
                ry="5.95"
              />
              <g>
                <polygon
                  class="cls-404-4"
                  points="331.7 298.75 221.28 310.12 221.28 277.62 331.7 266.25 331.7 298.75"
                />
                <polygon
                  class="cls-404-15"
                  points="228.25 284.15 324.74 273.68 324.74 286.24 228.25 296.71 228.25 284.15"
                />
                <polygon
                  class="cls-404-16"
                  points="228.25 296.71 324.74 286.24 324.74 279.52 228.25 289.99 228.25 296.71"
                />
              </g>
              <g>
                <path
                  class="cls-404-10"
                  d="M286.41,219.41c.14,2.11-1.46,3.94-3.58,4.08-2.11,.14-3.94-1.46-4.08-3.58-.14-2.11,1.46-3.94,3.58-4.08,2.12-.14,3.94,1.46,4.08,3.58Z"
                />
                <path
                  class="cls-404-10"
                  d="M302.68,217.98c.14,2.11-1.46,3.94-3.58,4.08-2.11,.14-3.94-1.46-4.08-3.58-.14-2.11,1.46-3.94,3.58-4.08,2.11-.14,3.94,1.46,4.08,3.58Z"
                />
                <path
                  class="cls-404-10"
                  d="M318.95,216.54c.14,2.11-1.46,3.94-3.58,4.08-2.11,.14-3.94-1.46-4.08-3.58-.14-2.11,1.46-3.94,3.58-4.08,2.11-.14,3.94,1.46,4.08,3.58Z"
                />
                <path
                  class="cls-404-10"
                  d="M335.23,215.11c.14,2.11-1.46,3.94-3.58,4.08-2.11,.14-3.94-1.46-4.08-3.58-.14-2.11,1.46-3.94,3.58-4.08,2.11-.14,3.94,1.46,4.08,3.58Z"
                />
              </g>
            </g>
            <g>
              <path
                class="cls-404-5"
                d="M346.71,135.94c-25.16,.95-50.21,2.9-75.31,4.84-6.75,.51-12.72-6.11-13.14-14.73-.5-9.75-.78-19.54-.83-29.3-.06-8.65,5.58-15.54,12.35-15.3,25.09,.96,50.15,2.19,75.25,2.65,6.75,.07,12.42,5.99,12.66,13.34,.33,9.98,.49,14.96,.82,24.94,.24,7.35-5.04,13.36-11.8,13.56Z"
              />
              <g>
                <path
                  class="cls-404-10"
                  d="M288.54,123.25c-.2,1.81-.29,2.72-.48,4.54-3.48,.19-5.23,.29-8.72,.49,.18-1.86,.28-2.78,.47-4.63-5.58,.26-8.37,.39-13.96,.66,.3-2.98,.45-4.47,.77-7.43,3.79-9.04,5.77-13.42,9.73-22.16,3.41,.06,5.12,.08,8.53,.15-3.21,7.71-4.82,11.56-7.93,19.47,1.57-.04,2.35-.06,3.91-.1,.37-3.26,.56-4.88,.95-8.13,3.5-.02,5.25-.04,8.74-.06-.39,3.19-.58,4.78-.95,7.98,1.27-.03,1.9-.04,3.17-.07-.44,3.65-.65,5.49-1.08,9.18-1.26,.05-1.9,.08-3.16,.14Z"
                />
                <path
                  class="cls-404-10"
                  d="M322.37,107.84c.36,9.47-5.62,19.15-15.66,19.72-6.95,.4-11.32-5.04-11.66-13.2-.39-9.44,5.29-19.87,15.76-19.78,6.93,.06,11.26,5.47,11.56,13.26Zm-8.48,1.49c-.11-3.48-1.7-5.77-4.25-5.77-3.6,0-6.25,3.89-6.09,9.16,.11,3.54,1.68,5.83,4.27,5.76,3.56-.1,6.22-3.97,6.06-9.14Z"
                />
                <path
                  class="cls-404-10"
                  d="M344.98,121.42c-.21,1.64-.31,2.46-.51,4.1-3.46,.08-5.19,.12-8.66,.23,.2-1.66,.31-2.49,.51-4.14-5.53,.13-8.29,.21-13.83,.38,.33-2.65,.5-3.98,.84-6.62,3.8-8.03,5.7-11.97,9.5-19.84,3.38,.02,5.07,.03,8.45,.04-3.09,7-4.64,10.51-7.74,17.61,1.55-.02,2.32-.03,3.87-.06,.37-2.95,.56-4.42,.93-7.36,3.46-.03,5.2-.04,8.66-.07-.37,2.92-.56,4.39-.93,7.31,1.26-.02,1.88-.03,3.14-.04-.44,3.36-.66,5.05-1.09,8.41-1.26,.02-1.88,.03-3.14,.06Z"
                />
              </g>
            </g>
            <path
              class="cls-404-10"
              d="M106.07,167.49l2.46,9.9c.46,1.84,1.89,3.27,3.73,3.73l9.9,2.46-9.9,2.46c-1.84,.46-3.27,1.89-3.73,3.73l-2.46,9.9-2.46-9.9c-.46-1.84-1.89-3.27-3.73-3.73l-9.9-2.46,9.9-2.46c1.84-.46,3.27-1.89,3.73-3.73l2.46-9.9Z"
            />
            <path
              class="cls-404-10"
              d="M444.61,160.8l1.67,6.72c.31,1.25,1.29,2.22,2.53,2.53l6.72,1.67-6.72,1.67c-1.25,.31-2.22,1.29-2.53,2.53l-1.67,6.72-1.67-6.72c-.31-1.25-1.29-2.22-2.53-2.53l-6.72-1.67,6.72-1.67c1.25-.31,2.22-1.29,2.53-2.53l1.67-6.72Z"
            />
            <path
              class="cls-404-10"
              d="M101.2,115.31l2.13,8.54c.39,1.59,1.63,2.83,3.22,3.22l8.54,2.13-8.54,2.13c-1.59,.39-2.83,1.63-3.22,3.22l-2.13,8.54-2.13-8.54c-.39-1.59-1.63-2.83-3.22-3.22l-8.54-2.13,8.54-2.13c1.59-.39,2.83-1.63,3.22-3.22l2.13-8.54Z"
            />
            <path
              class="cls-404-10"
              d="M429.84,110.53l1.59,6.39c.3,1.19,1.22,2.12,2.41,2.41l6.39,1.59-6.39,1.59c-1.19,.3-2.12,1.22-2.41,2.41l-1.59,6.39-1.59-6.39c-.3-1.19-1.22-2.12-2.41-2.41l-6.39-1.59,6.39-1.59c1.19-.3,2.12-1.22,2.41-2.41l1.59-6.39Z"
            />
            <path
              class="cls-404-10"
              d="M72.56,142.03l1.17,4.71c.22,.87,.9,1.56,1.78,1.78l4.71,1.17-4.71,1.17c-.87,.22-1.56,.9-1.78,1.78l-1.17,4.71-1.17-4.71c-.22-.87-.9-1.56-1.78-1.78l-4.71-1.17,4.71-1.17c.87-.22,1.56-.9,1.78-1.78l1.17-4.71Z"
            />
            <path
              class="cls-404-10"
              d="M424.72,199.42l1.32,5.29c.24,.98,1.01,1.75,1.99,1.99l5.29,1.32-5.29,1.32c-.98,.24-1.75,1.01-1.99,1.99l-1.32,5.29-1.32-5.29c-.24-.98-1.01-1.75-1.99-1.99l-5.29-1.32,5.29-1.32c.98-.24,1.75-1.01,1.99-1.99l1.32-5.29Z"
            />
          </g>
        </g>
      </svg>
      <h2 class="container-404__tittle">
        ¡Vaya!, No hemos encontrado lo que estás buscando
      </h2>
      <p class="container-404__paragraph">
        Parece que la página ya no existe o ha cambiado de dirección
      </p>
      <a class="container-404__button" href="javascript: history.go(-1)"
        >Volver atrás</a
      >
    </div>
  </section>
  <CustomCursor />
</template>

<script>
import CustomCursor from "@/components/customCursor/CustomCursor.vue";
import PaginaCarga from "@/components/paginaCarga/paginaCarga.vue";
export default {
  components: {
    CustomCursor,
    PaginaCarga,
  },
  data: {
    isMovile: window.innerHeight > window.innerWidth,
  }
};
</script>